/**
 *  [ ] Strength - Allwos higher damage and faster bow times
  - [ ] Vitality - Defense and max HP
  - [ ] Dexterity - Higher % of Critical strike
  - [ ] Intelligence - Higher damage of MP skills and max MP
 * 
 */
export default class CharacterAttributes {
  static AttributePointsOnLevel = 5;
  static SkillPointsOnLevel = 2;

  public MaxHealthPoints = 100;
  public HealthPoints = 100;

  public MaxManaPoints = 50;
  public ManaPoints = 50;

  // Each str is 1 damage and 50ms off bow
  public Strength: number = 1;
  public Vitality: number = 1;
  public Dexterity: number = 1;
  public Intelligence: number = 1;

  public AvailableAttributePoints: number = 0;
  public AvailableSkillPoints: number = 0;
}
